import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { StaggerGroup, staggerItem } from "./Reveal";

const REVIEWS = [
  {
    quote: "DOX caught a license renewal I completely forgot about. It literally saved my ability to bid on a $400k job.",
    name: "Marcus Reyes",
    role: "GC · Reyes Construction",
    initials: "MR",
  },
  {
    quote: "It's like hiring an admin who never sleeps and never makes mistakes. I upload, and it's just… handled.",
    name: "Danielle Cho",
    role: "Owner · Cho Electrical",
    initials: "DC",
  },
  {
    quote: "The plain-English explanations are gold. I finally understand my insurance requirements without calling my broker.",
    name: "Tyrell Banks",
    role: "Plumbing Contractor",
    initials: "TB",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 sm:py-32 bg-surface/30 border-y border-white/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-dox-magenta mb-4">Trusted by trades</div>
          <h2 className="font-display font-black tracking-tight text-4xl sm:text-5xl leading-[1.05]">
            Contractors who <span className="text-gradient-brand">fired the paperwork.</span>
          </h2>
        </div>

        <StaggerGroup className="grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r) => (
            <motion.div
              key={r.name}
              variants={staggerItem}
              className="rounded-2xl border border-white/10 bg-ink p-7 hover:border-dox-orange/30 transition-colors"
            >
              <div className="flex gap-1 mb-5 text-dox-orange">
                {[...Array(5)].map((_, i) => <Star key={i} size={15} fill="currentColor" />)}
              </div>
              <p className="text-white/80 leading-relaxed">“{r.quote}”</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-gradient-to-br from-dox-orange to-dox-purple flex items-center justify-center font-bold text-sm text-white">
                  {r.initials}
                </div>
                <div>
                  <div className="text-sm font-semibold text-white">{r.name}</div>
                  <div className="text-xs text-white/45">{r.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
